import { BaseModal } from "./base_modal"

export default class extends BaseModal {
}